<template>
  <el-select
    class="userSelect"
    v-model="value"
    size="small"
    filterable
    remote
    style="width:200px"
    :clearable="true"
    reserve-keyword
    :placeholder="title"
    :remote-method="remoteMethod"
    :loading="loading"
    @visible-change="showTaggle"
    @change="print"
    @clear="clear"
  >
    <i
      class="userSelect__icon el-icon-user"
      slot="prefix"
    />
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.label"
      :value="index"
      class="userSelect__option"
    >
      <span
        class="userSelect__label"
        :title="item.label"
      >{{ item.label }}</span>
      <span
        class="userSelect__desc"
        :title="item.desc"
      >{{ item.desc }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { mapState } from "vuex";
import { throttle } from "@/assets/js/base";

export default {
  data() {
    return {
      options: [],
      value: [],
      loading: false
    };
  },
  props: {
    title: {
      type: String,
      default: "请输入用户名"
    }
  },
  computed: {
    ...mapState(["USERLIST", "USER"]),
    list() {
      // const userList = this.treeConvertList(this.USERLIST).map(item => {
      //   if (this.USER.userId !== item.id) {
      //     return ({
      //       label: item.username,
      //       value: {...item},
      //       desc: "用户名"
      //     })
      //   }
      // })
      const userList = this.treeConvertList(this.USERLIST).map(item => ({
        label: item.username,
        value: { ...item },
        desc: "用户名"
      }));
      return userList;
    }
  },
  mounted() {},
  methods: {
    //将树形图转扁平数据
    treeConvertList(root) {
      const list = [];
      if (root) {
        const queue = JSON.parse(JSON.stringify(root));
        while (queue.length) {
          const node = queue.shift();
          if (node.userList && node.userList.length) {
            queue.push(...node.userList);
          }
          delete node.userList;

          if (node.parentId !== null && node.parentId !== undefined) {
            list.push(node);
          }
        }
      }
      return list;
    },
    //弹窗显示/隐藏时触发
    showTaggle(data) {
      if (data) {
        this.$emit("input", null);
        this.value = null
      }
    },
    clear() {
      this.$emit("input", null);
    },
    print(i) {
      if (this.value === null || this.value === "") {
        this.$emit("input", null);
        return;
      }
      this.$emit("input", this.options[i].value);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        throttle(async () => {
          this.options = this.list.filter(item => {
            return item.value.id != this.USER.userId && item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
          this.loading = false;
        }, 100);
      } else {
        this.options = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.userSelect {
  &__icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
  }

  &__option {
    display: flex;
  }

  &__label {
    @include ellipsis();
    flex: 1;
  }

  &__desc {
    @include ellipsis();
    margin-left: 5px;
    flex: 1;
    color: #8492a6;
    font-size: 13px;
    text-align: right;
  }
}
</style>
